<template>
  <!-- 用户管理- 实名认证-->
  <div class="query-real-name-box">
    <!-- header头部 -->
    <h3>查询实名认证</h3>
    <br />
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="query.name"
            placeholder="请输入用户名字或身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column prop="name" label="用户名称" align="center">
          <template slot-scope="{ row }">
            {{ row.name }}
            <i
              class="el-icon-s-order"
              v-if="row"
              v-clipboard:copy="row.name"
              v-clipboard:success="onCopy"
              style="font-size: 24px; cursor: pointer"
              title="复制"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="id_card" label="身份证" align="center">
          <template slot-scope="{ row }">
            {{ row.id_card }}
            <i
              class="el-icon-s-order"
              v-if="row"
              v-clipboard:copy="row.id_card"
              v-clipboard:success="onCopy"
              style="font-size: 24px; cursor: pointer"
              title="复制"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { server, delData, patchData, getData, postApiData, getApiData } from '@/http'
export default {
  data() {
    return {
      loading: false,
      query: {
        user_id: undefined,
        name: undefined,
      },
      dataList: undefined,
    }
  },
  created() {

  },
  methods: {
    onCopy() {
      this.$message.success('已成功复制到粘贴板')
    },
    getData() {
      //获取数据
      if (!this.query.user_id && !this.query.name) {
        this.$message.warning("必填一个搜索项")
        return
      }
      let params = this.query
      this.loading = true
      getApiData(`user_id_card_list`, params)
        .then(res => {
          this.dataList = res
        }).finally(() => {
          this.loading = false
        })
    },
  }
}
</script>
<style lang="less" scoped>
</style>